import { render, staticRenderFns } from "./MatchingJobs.vue?vue&type=template&id=374415e0&scoped=true"
import script from "./MatchingJobs.vue?vue&type=script&lang=ts"
export * from "./MatchingJobs.vue?vue&type=script&lang=ts"
import style0 from "./MatchingJobs.vue?vue&type=style&index=0&id=374415e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374415e0",
  null
  
)

export default component.exports